import { render } from "./SignupForm.vue?vue&type=template&id=19262763"
import script from "./SignupForm.vue?vue&type=script&lang=js"
export * from "./SignupForm.vue?vue&type=script&lang=js"

import exportComponent from "/Volumes/work/crypto/nfty.today/vueSite/v1/node_modules/vue-loader-v16/dist/exportHelper.js"
export default /*#__PURE__*/exportComponent(script, [['render',render]])